import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import CallToNumberDetailTableComponent from "../../components/panel/call-to-number-detail/CallToNumberDetailTable";

export default function CallToNumberDetailPage() {
  const [walletReload, setWalletReload] = useState<boolean>(false);

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                شماره های پیام صوتی
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                شماره های پیام صوتی
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            ></Stack>
          </Stack>
        </Stack>
        <CallToNumberDetailTableComponent
          walletReload={walletReload}
          setWalletReload={setWalletReload}
        />
      </Stack>
    </>
  );
}
